import {BaseService} from "@/core/services/BaseService";

class ServiceService extends BaseService<any> {
    endpoint = "/service";
}

export default new ServiceService();